import { translateString } from 'i18n/translateString';

export enum AppRoutesEnum {
  HOME = '/',
  /** Deprecated route, still used to redirect old bookmarks to new guide in sheet */
  GUIDE = '/guide',
  SUMMARY = '/summary',
  ERROR = '/error',
  PLANNER = '/planner',
  PLANNER_MEASUREMENTS = '/planner/measurements',
  PLANNER_LAYOUTS = '/planner/layouts',
  PLANNER_FRAMES = '/planner/frames',
  PLANNER_PANELS = '/planner/panels',
  PLANNER_PANEL_PATTERNS = '/planner/panels/patterns',
  PLANNER_DOOR_HEIGHTS = '/planner/door-heights',
  PLANNER_CHR = '/planner/chr',
  PLANNER_CUTTING = '/planner/cutting',
  PLANNER_DISTANCES = '/planner/distances',
  PLANNER_STOPBARS = '/planner/stopbars',
  PLANNER_LIST = '/planner/list',
  PLANNER_STORAGE_BEHIND = '/planner/storage-behind',
  PLANNER_STORAGE_BEHIND_GALLERY = '/planner/storage-behind/gallery',
  PLANNER_STORAGE_BEHIND_IMPORTED = '/planner/storage-behind/imported',
  NO_MATCH = '/*'
}

export enum ViewIds {
  HOME = 'intro',
  GUIDE = 'guide',
  SUMMARY = 'summary',
  PLANNER = 'planner',
  ERROR = 'error'
}

export const isPlannerRoute = (pathname: string) => {
  return pathname === AppRoutesEnum.PLANNER || pathname.startsWith(`${AppRoutesEnum.PLANNER}/`);
};

export const getViewIdAriaLabel = (id: string) => {
  switch (id) {
    case ViewIds.HOME:
      return translateString('pagesIntro');
    case ViewIds.PLANNER:
      return translateString('pagesPlanner');
    case ViewIds.GUIDE:
      return translateString('pagesGuide');
    case ViewIds.SUMMARY:
      return translateString('pagesSummary');
    default:
      return id;
  }
};
